import {track} from "@/services/track-custom";
import store  from '@/store/index';

export const misMixins = {
  methods: {
    clickBanner (item, data_track) {
      if (data_track.content_popup) track.trackEventCluvi(data_track, 'click popup');
      if (data_track.content_home) track.trackEventCluvi(data_track, 'click banner');
      if (!item.url) return;
      if (item.url.tipe === "producto") {
        this.$router.push({
          name: "Product",
          params: { supplier_id: store.state.customer.supplier.slug, product_id: item.url.param }
        });
      } else if (item.url.tipe === "categoria") {
        this.$router.push({
          name: "Menu",
          params: { supplier_id: store.state.customer.supplier.slug },
          query: { category_id: item.url.param }
        });
      };
      let url = item.url.param;
      if (item?.layout_type === 'banner') {
        const includeCluvi = item.url.param.includes('.cluvi.');
        if (includeCluvi) url = `${url}${store.state.ontable.tableId? `?mesa=${store.state.ontable.tableId}`:''}`.trim();
      };
      if(item.url.tipe === "externo") {
        if (item.url && item.url.target) window.open(url, item.url.target);
        else window.open(url, item.target);
      }
    },
    back() {
      if (this.$route.name === "Product") {
        if (store.state.order.service === "on_table") {
          this.$router.push({
            name: "OnTableHome",
            params: { supplier_id: store.state.customer.supplier.slug }
          });
        } else {
          this.$router.push({
            name: "Home",
            params: { supplier_id: store.state.customer.supplier.slug }
          });
        };
      } else {
        this.$router.go(-1);
      };
    }
  }
}